var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('img',{staticClass:"title__icon",attrs:{"src":"/img/icon_kyouka/icon_kyouka_sugaku.png","alt":"icon"}}),_c('div',{staticClass:"title__text text-large font-medium"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }